module.exports = __webpack_public_path__ + "img/tickets-r3-issues.eca0a99f.png";